import { Outlet, useParams } from "react-router"
import { Flex, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { PatientSideBar } from "@/components/app/SideBars/PatientSideBar.tsx"
import { PatientInfo } from "@/components/app/PatientInfo.tsx"
import { Container } from "@/components/ui/Container.tsx"

export function Patient() {
  const { id } = useParams()
  return (
    <Flex height="100%" width="100%">
      <PatientSideBar />
      <Container>
        <View width="100%" margin="size-65"
          // backgroundColor="gray-200"
          borderRadius="regular"
          overflow="scroll"
        >
          <Flex direction={"column"} gap={"size-65"}>
            <View>
              {id && <PatientInfo id={id as unknown as number} />}
            </View>
            <View>

            </View>
            <Container>
              <View width="100%" height="100%" margin="size-65" overflow={"auto"}>
                <Outlet />
              </View>
            </Container>
          </Flex>

          {/*<Flex height={"100%"}>*/}
          {/*  <View*/}
          {/*    overflow="scroll"*/}
          {/*    height="100%"*/}
          {/*    width="100%"*/}
          {/*    UNSAFE_style={{*/}
          {/*      scrollBehavior: "smooth",*/}
          {/*      scrollbarWidth: "none",*/}
          {/*      msOverflowStyle: "none",*/}
          {/*    }}*/}
          {/*  >*/}
          {/*  </View>*/}
          {/*</Flex>*/}
        </View>
      </Container>
    </Flex>
  )
}
